import PropTypes from 'prop-types'
import { Component } from 'react'

import Link from 'components/link'
import { helloBabyPostPath } from 'lib/urls'
import classNames from 'classnames'

export default class PostLink extends Component {
  static propTypes = {
    direction: PropTypes.oneOf(['left', 'right']),
    post: PropTypes.object.isRequired,
    className: PropTypes.string,
  }

  render() {
    const { className, direction, post } = this.props

    return (
      <Link
        className={classNames('h6 link-primary', className)}
        to={helloBabyPostPath(post.slug)}
      >
        {direction === 'left' ? (
          <i className="h7 mrs fa fa-chevron-left" />
        ) : null}
        <span>
          {post.title.substring(0, 35)}
          {post.title.length > 35 ? '...' : null}
        </span>
        {direction === 'right' ? (
          <i className="h7 mls fa fa-chevron-right" />
        ) : null}
      </Link>
    )
  }
}
